import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { Checkbox } from 'primeng/checkbox';
import { Select } from 'primeng/select';
import { Fluid } from 'primeng/fluid';
import { FreeCoinIcon } from '@/app/components/icons/free-coin-icon';
import { PaidCoinIcon } from '@/app/components/icons/paid-coin-icon';
import { CategoryCurrencyConfig } from '@/lib-backend';

/** Reusable, presentation-only editor for a CategoryCurrencyConfig. */
@Component({
    selector: 'app-category-currency-form',
    standalone: true,
    imports: [FormsModule, InputNumber, Checkbox, Select, Fluid, FreeCoinIcon, PaidCoinIcon],
    templateUrl: './category-currency-form.html',
})
export class CategoryCurrencyForm {
    readonly value = model.required<CategoryCurrencyConfig>();
    readonly disabled = input<boolean>(false);

    static readonly CURRENCY_TYPES = [
        { value: 'default', label: 'default — whole units' },
        { value: 'default_cent', label: 'default_cent — cents (÷100)' },
    ];

    protected readonly currencyTypeOptions = CategoryCurrencyForm.CURRENCY_TYPES;

    protected setField<K extends keyof CategoryCurrencyConfig>(field: K, v: CategoryCurrencyConfig[K]): void {
        this.value.update(d => ({ ...d, [field]: v }));
    }

    protected setInitialFunds(field: 'FreeCredits' | 'PaidCredits', v: number): void {
        this.value.update(d => ({ ...d, InitialFunds: { ...d.InitialFunds, [field]: v } }));
    }

    protected setCreditsPerDollar(field: 'FreeCredits' | 'PaidCredits', v: number): void {
        this.value.update(d => ({ ...d, CreditsPerDollar: { ...d.CreditsPerDollar, [field]: v } }));
    }
}
